/* eslint-disable camelcase */
import { matchPath, useLocation } from 'react-router-dom';

import { PageContextEnum, Recommendation } from '@/api/rest/resources/types/recommendations';
import { usePathSet } from '@/hooks/usePathSet';

// TODO: MVP-CW review all these pages in SITE_MAPPING
const useSitesMapping = () => {
  const paths = usePathSet();

  return {
    [PageContextEnum.global]: [],
    [PageContextEnum.portfolio]: [paths.portfolio],
    [PageContextEnum.dashboard]: [paths.projects, paths.projectDetails, paths.dashboard],
    [PageContextEnum.indicators]: [paths.indicators],
    [PageContextEnum.contracts]: [paths.portfolio],
    [PageContextEnum.reports]: [paths.reports],
    [PageContextEnum.knowledge]: [paths.knowledge],
    [PageContextEnum.copilot]: [paths.copilot],
    [PageContextEnum.carbon]: [paths.carbonDetails],
    [PageContextEnum.water]: [paths.waterDetails],
    [PageContextEnum.biodiversity]: [paths.biodiversityDetails],
    [PageContextEnum.soil]: [paths.soilDetails],
    [PageContextEnum.social]: [paths.socialDetails],
    [PageContextEnum.plots]: [paths.plots],
  };
};

export const useFilterRecommendationsBySite = (recommendations: Recommendation[]): Recommendation[] => {
  const { pathname } = useLocation();
  const sitesMapping = useSitesMapping();

  return recommendations.filter((recommendation) => {
    const { site_pages } = recommendation;

    if (sitesMapping[PageContextEnum.copilot].includes(pathname)) {
      return true;
    }

    if (!site_pages || site_pages.length === 0) {
      return false;
    }

    if (site_pages.includes(PageContextEnum.global)) {
      return true;
    }

    const allowedSites = site_pages
      .map((site) => sitesMapping[`${site}`])
      .flat()
      .filter(Boolean);

    return allowedSites.find((allowedSite) => matchPath(allowedSite, pathname));
  });
};
